import { Component, OnInit } from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BehaviorSubject } from 'rxjs';
import { PortalManagementPackagesService } from 'src/app/features/portal/_services/management/portal-management-packages.service';
import { PortalPackagesService } from 'src/app/features/portal/_services/portal/portal-packages.service';

@Component({
  selector: 'app-subscriptions-upgrade-dialog',
  templateUrl: './subscriptions-upgrade-dialog.component.html',
  styleUrls: ['./subscriptions-upgrade-dialog.component.scss']
})
export class SubscriptionsUpgradeDialogComponent implements OnInit {
  currentPackage: any;
  selectedPackage: any;
  constructor(
    private fb: FormBuilder,
    public config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    public pmps: PortalManagementPackagesService
  ) {}

  packages = this.pmps.packages
    .sort((a, b) => a.speed_down_mbps - b.speed_down_mbps)
    .map((p) => {
      return {
        ...p,
        disable: p.id === this.config.data.subscription.portal_product_id
      };
    });

  packages$: BehaviorSubject<any[]> = BehaviorSubject.create(this.packages);

  upgradeSubscriptionForm: FormGroup<any> = this.fb.group({
    subscription_id: ['', Validators.required],
    upgrade_product_id: ['', Validators.required],
    apply_immediately: [false]
  });

  applyImmediatelyOptions = [
    { label: 'Queue for next billing date', value: false },
    { label: 'Issue immediately', value: true }
  ];

  get selectedPackageObject(): any {
    const id = this.upgradeSubscriptionForm.get('upgrade_product_id')?.value;
    return this.packages.find((p) => p.id === id);
  }

  get isDowngrade(): boolean {
    const selected = this.selectedPackageObject;
    return (
      !!this.currentPackage &&
      !!selected &&
      selected.speed_down_mbps < this.currentPackage.speed_down_mbps
    );
  }

  ngOnInit(): void {
    console.log('config we get', this.config);
    this.pmps.getPortalPackagesManagement().subscribe((packages) => {
      console.log('packages we get back', packages);
      this.packages = packages;
      this.packages
        .sort((a: any, b: any) => a.speed_down_mbps - b.speed_down_mbps)
        .map((p: { id: any }) => {
          return {
            ...p,
            disable: p.id === this.config.data.subscription.portal_product_id
          };
        });

      this.currentPackage = this.packages.find(
        (p) => p.id === this.config.data.subscription.portal_product_id
      );
    });

    this.upgradeSubscriptionForm.patchValue({
      subscription_id: this.config.data.subscription.id
    });

    // The queue-vs-immediate choice only applies to a downgrade - reset it
    // whenever the selection changes away from one, so it can't silently
    // linger true against an upgrade (where it has no effect anyway).
    this.upgradeSubscriptionForm.get('upgrade_product_id')!.valueChanges.subscribe(() => {
      if (!this.isDowngrade) {
        this.upgradeSubscriptionForm.patchValue({ apply_immediately: false }, { emitEvent: false });
      }
    });

    console.log(this.currentPackage);
  }

  onUpgradeSubscriptionSumbit() {
    if (this.upgradeSubscriptionForm.invalid) {
      return;
    }

    this.ref.close(this.upgradeSubscriptionForm.value);
  }
}
